module.exports = __webpack_public_path__ + "img/simple_email.b3df5e12.jpg";